import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Kasir from "@/pages/Kasir";
import Purchases from "@/pages/Purchases";
import PPOB from "@/pages/PPOB";
import Stock from "@/pages/Stock";
import HpPrices from "@/pages/HpPrices";
import Services from "@/pages/Services";
import ServicePrices from "@/pages/ServicePrices";
import Customers from "@/pages/Customers";
import Suppliers from "@/pages/Suppliers";
import Debts from "@/pages/Debts";
import Expenses from "@/pages/Expenses";
import Attendance from "@/pages/Attendance";
import Staff from "@/pages/Staff";
import Tasks from "@/pages/Tasks";
import ContentSchedule from "@/pages/ContentSchedule";
import Performance from "@/pages/Performance";
import Reports from "@/pages/Reports";
import CashDrawer from "@/pages/CashDrawer";
import SalesHistory from "@/pages/SalesHistory";
import StockAnalysis from "@/pages/StockAnalysis";
import ActivityLog from "@/pages/ActivityLog";
import Spareparts from "@/pages/Spareparts";
import Assets from "@/pages/Assets";
import Kasbon from "@/pages/Kasbon";
import Payroll from "@/pages/Payroll";
import Branches from "@/pages/Branches";
import Transfers from "@/pages/Transfers";
import GlobalStock from "@/pages/GlobalStock";
import NetProfit from "@/pages/NetProfit";
import Profile from "@/pages/Profile";
import CekImei from "@/pages/CekImei";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

const PrivRoute = ({ children }) => {
  const { user, isPriv } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!isPriv) return <Navigate to="/kasir" replace />;
  return <Layout>{children}</Layout>;
};

const HomeRoute = () => {
  const { user, isPriv } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!isPriv) return <Navigate to="/kasir" replace />;
  return <Layout><Dashboard /></Layout>;
};

const ROUTES = [
  ["/kasir", Kasir],
  ["/riwayat-penjualan", SalesHistory],
  ["/cash-drawer", CashDrawer],
  ["/ppob", PPOB],
  ["/pengeluaran", Expenses],
  ["/pembelian", Purchases, true],
  ["/produk", Products, true],
  ["/sparepart", Spareparts, true],
  ["/stok", Stock],
  ["/cek-stok", GlobalStock],
  ["/transfer", Transfers],
  ["/analisis-stok", StockAnalysis, true],
  ["/harga-hp", HpPrices],
  ["/service", Services],
  ["/harga-service", ServicePrices],
  ["/cek-imei", CekImei],
  ["/absensi", Attendance],
  ["/konten", ContentSchedule],
  ["/pelanggan", Customers],
  ["/supplier", Suppliers, true],
  ["/hutang-piutang", Debts, true],
  ["/jobdesk", Tasks, true],
  ["/staf", Staff, true],
  ["/kasbon", Kasbon, true],
  ["/penggajian", Payroll, true],
  ["/kinerja", Performance, true],
  ["/log-aktivitas", ActivityLog, true],
  ["/aset", Assets, true],
  ["/laporan", Reports, true],
  ["/laba-bersih", NetProfit, true],
  ["/cabang", Branches, true],
  ["/profil", Profile],
];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<HomeRoute />} />
          {ROUTES.map(([path, C, priv]) => (
            <Route
              key={path}
              path={path}
              element={priv ? <PrivRoute><C /></PrivRoute> : <Protected><C /></Protected>}
            />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
